module.exports = __webpack_public_path__ + "static/media/MarketingMaterials.06d045fe.jpg";